import {
  RtmpDestinationEntityId,
  rtmpDestinationEntityId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseRequestDTO } from "@youm-front/common/domain";

export class RtmpDestinationDeleteRequestDTO extends BaseRequestDTO<RtmpDestinationDeleteRequestDTORaw> {
  private static validateFunction = JsonSchemaValidator.compile(
    RtmpDestinationDeleteRequestDTO.validationSchema()
  );

  constructor(value: RtmpDestinationDeleteRequestDTORaw) {
    super(
      JsonSchemaValidator.assert(
        RtmpDestinationDeleteRequestDTO.validateFunction,
        value
      )
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["id"],
      properties: {
        id: rtmpDestinationEntityId
      },
      additionalProperties: false
    };
  }

  override toJSON(): object {
    throw new Error("Should not be used");
  }
}

interface RtmpDestinationDeleteRequestDTORaw {
  id: RtmpDestinationEntityId;
}
